import React from 'react'
import { cn } from '@/lib/utils'

export type Status = string

function variantForStatus(status: string): 'success' | 'warning' | 'destructive' | 'secondary' | 'muted' {
  const s = (status || '').toLowerCase()
  if (s === 'retired') return 'muted'
  if (['syncing', 'auth_ok', 'ok', 'running'].includes(s)) return 'success'
  if (['paused', 'idle', 'pending', 'token_expiring'].includes(s)) return 'warning'
  if (['deleted', 'error', 'failed', 'token_expired', 'unauthorized'].includes(s)) return 'destructive'
  return 'secondary'
}

export function StatusBadge({ status, className }: { status: Status; className?: string }) {
  const variant = variantForStatus(String(status))
  const color =
    variant === 'success'
      ? 'bg-success/15 text-success border-success/40'
      : variant === 'warning'
        ? 'bg-warning/15 text-warning border-warning/40'
        : variant === 'destructive'
          ? 'bg-destructive/15 text-destructive border-destructive/40'
          : variant === 'muted'
            ? 'bg-muted text-muted-foreground border-border'
            : 'bg-secondary text-secondary-foreground border-secondary/40'
  return (
    <span className={cn('inline-flex items-center rounded border px-2 py-0.5 text-xs font-medium', color, className)}>
      {status === 'retired' ? 'Megszűnt' : status}
    </span>
  )
}

